import { FunctionComponent } from 'react'

import config from '@config'
import EmbeddedContent from '@components/EmbeddedContent'

const {
  socialembeds: { instagramEmbedStaticPageUrl },
} = config

interface InstagramComponentProps {
  url: string
}

const InstagramComponent: FunctionComponent<InstagramComponentProps> = ({
  url,
}) => <EmbeddedContent url={`${instagramEmbedStaticPageUrl}${url}`} />

export default InstagramComponent
